import { render, staticRenderFns } from "./PDPReviews.vue?vue&type=template&id=f7e4043e&scoped=true"
import script from "./PDPReviews.vue?vue&type=script&lang=js"
export * from "./PDPReviews.vue?vue&type=script&lang=js"
import style0 from "./PDPReviews.vue?vue&type=style&index=0&id=f7e4043e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e4043e",
  null
  
)

export default component.exports